"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestAccountsSubProvider = void 0;
const tslib_1 = require("tslib");
const subproviders_1 = require("@0x/subproviders");
class RequestAccountsSubProvider extends subproviders_1.Subprovider {
    constructor(venlyWalletSubProvider) {
        super();
        this.venlyWalletSubProvider = venlyWalletSubProvider;
    }
    /**
     * This method conforms to the web3-provider-engine interface.
     * It is called internally by the ProviderEngine when it is this subproviders
     * turn to handle a JSON RPC request.
     * @param payload JSON RPC payload
     * @param next Callback to call if this subprovider decides not to handle the request
     * @param end Callback to call if subprovider handled the request and wants to pass back the request.
     */
    // tslint:disable-next-line:prefer-function-over-method async-suffix
    handleRequest(payload, next, end) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            switch (payload.method) {
                case 'eth_requestAccounts':
                    let result = yield this.venlyWalletSubProvider.getAccountsAsync();
                    end(null, result);
                    return;
                default:
                    next();
                    return;
            }
        });
    }
}
exports.RequestAccountsSubProvider = RequestAccountsSubProvider;
//# sourceMappingURL=RequestAccountsSubProvider.js.map